// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IForgotUsernameRequestDto
 */
export interface IForgotUsernameRequestDto {
    /**
     * 
     * @type {string}
     * @memberof IForgotUsernameRequestDto
     */
    email?: string;
}

/**
 * Check if a given object implements the IForgotUsernameRequestDto interface.
 */
export function instanceOfIForgotUsernameRequestDto(value: object): value is IForgotUsernameRequestDto {
    return true;
}

export function IForgotUsernameRequestDtoFromJSON(json: any): IForgotUsernameRequestDto {
    return IForgotUsernameRequestDtoFromJSONTyped(json, false);
}

export function IForgotUsernameRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IForgotUsernameRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
    };
}

export function IForgotUsernameRequestDtoToJSON(json: any): IForgotUsernameRequestDto {
    return IForgotUsernameRequestDtoToJSONTyped(json, false);
}

export function IForgotUsernameRequestDtoToJSONTyped(value?: IForgotUsernameRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
    };
}

